import 'select2/dist/js/select2.full.js'
import './infobubble'
// import './markerclusterer'

var my_lat = '';
var my_lng = '';

function showPosition(position) {

    my_lat = position.coords.latitude;
    my_lng = position.coords.longitude;

    vm.get_stores_around();
}

var map;
var markers = [];
var prev_info = false;
var mark_clust = null;
var info_bubble = null;


function CenterControl(controlDiv, map) {
  // Set CSS for the control border.
  const controlUI = document.createElement("div");
  controlUI.style.backgroundColor = "#fff";
  controlUI.style.border = "2px solid #fff";
  controlUI.style.borderRadius = "3px";
  controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlUI.style.cursor = "pointer";
  controlUI.style.marginRight = "10px";
  controlUI.style.marginTop = "10px";
  controlUI.style.textAlign = "center";
  controlUI.title = "Click to reset the map";
  controlDiv.appendChild(controlUI);
  // Set CSS for the control interior.
  const controlText = document.createElement("div");
  controlText.style.color = "rgb(25,25,25)";
  controlText.style.fontFamily = "Roboto,Arial,sans-serif";
  controlText.style.fontSize = "16px";
  controlText.style.lineHeight = "38px";
  controlText.style.paddingLeft = "5px";
  controlText.style.paddingRight = "5px";
  controlText.innerHTML = "Reset";
  controlUI.appendChild(controlText);
  // Setup the click event listeners: simply set the map to Chicago.
  controlUI.addEventListener("click", () => {
    // map.setCenter({ lat: -34.397, lng: 150.644 });
    map.setZoom(2);
  });
}


function initMap() {

	var map_holder = document.getElementById('storefinder__map')

	if( typeof(map_holder) == 'undefined' || map_holder == null || map_holder.length == '0' )
		return;

    map = new google.maps.Map(map_holder, {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 2,
		mapTypeControl: false,
		streetViewControl: false,
		scrollwheel: false,
		fullscreenControl: false,
    });

    map.set('styles',
		[
		    {
		        "featureType": "all",
		        "stylers": [
		            {
		                "saturation": 0
		            },
		            {
		                "hue": "#e7ecf0"
		            }
		        ]
		    },
		    {
		        "featureType": "road",
		        "stylers": [
		            {
		                "saturation": -70
		            }
		        ]
		    },
		    {
		        "featureType": "transit",
		        "stylers": [
		            {
		                "visibility": "off"
		            }
		        ]
		    },
		    {
		        "featureType": "poi",
		        "stylers": [
		            {
		                "visibility": "off"
		            }
		        ]
		    },
		    {
		        "featureType": "water",
		        "stylers": [
		            {
		                "visibility": "simplified"
		            },
		            {
		                "saturation": -60
		            }
		        ]
		    }
		]
	);

    info_bubble = new InfoBubble({
        shadowStyle: false,
        padding: 16,
        borderRadius: 0,
        backgroundColor: base_color,
		backgroundColor: '#ffffff',
        minWidth: 300,
        maxWidth: 300,
		minHeight: 'auto',
        maxHeight: 'auto',
        disableAutoPan: false,
        closeSrc: assets_src +"svg/close.svg",
        hideCloseButton: false,
        // borderWidth: 1,
        borderColor: '#ffffff',
        backgroundClassName: 'storefinder__map__infobox',
        disableAnimation: true,
		overflow: 'visible',
		shadowStyle: 1
    });

	//info_bubble.setBubbleOffset(0,-32);

	google.maps.event.addListener(info_bubble,'closeclick',function(){
		vm.marker = '';
	});

	const centerControlDiv = document.createElement("div");
	  CenterControl(centerControlDiv, map);
	  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(centerControlDiv);

}

//var marker_icon = new google.maps.MarkerImage( assets_src + "/svg/map-marker.png", null, null, null, new google.maps.Size(30,40));
var marker_icon = {
    path :"M11,0.9c-6.1,0-11,4.9-11,11c0,2.7,1,5.3,2.8,7.3L11,28l8.2-8.8c1.8-2,2.8-4.6,2.8-7.3C22,5.8,17,0.9,11,0.9z M11,15.3c-1.9,0-3.5-1.6-3.5-3.5S9,8.4,11,8.4c1.9,0,3.5,1.6,3.5,3.5S12.9,15.3,11,15.3z",
    fillColor: base_color,
    strokeColor:'white',
    strokeAlignment:'center',
    fillOpacity: 1,
    anchor: new google.maps.Point(11,28),
    strokeWeight: 1.6,
    scale: 1.1
}

function addMarker(location, content ) {

    var marker = new google.maps.Marker({
        position: location,
		icon: marker_icon,
        title: String(content.title),
		map: map
    });

    var latLng = new google.maps.LatLng( location );

    var fn = markerClickFn( content, latLng );
    google.maps.event.addListener( marker, 'click', markerClickFn( content, latLng, 'clicking' ) );

    markers.push(marker);

	// if( window.show_sidebar == false )
	// 	fn( content, latLng, 'clicking' )

}

function displayMarkers(data) {

    markers = [];

    for ( var i = 0; i < data.length; i++) {

        var lat = data[i].address.lat;
        var lng = data[i].address.lng;

        if ( typeof lat == 'string' )
           lat = parseFloat( lat )

        if ( typeof lng == 'string' )
           lng = parseFloat( lng )

        addMarker(
            {
                'lat': lat,
                'lng': lng
            },
            {
                'title'		: data[i].title,
                'logo'		: data[i].logo,
                'name'		: data[i].name,
                'address'	: data[i].address.address,
                'phone'		: data[i].phone,
                'email'		: data[i].email,
                'position'	: data[i].position,
                'ex_url'	: data[i].ex_url,
            }
        )

    }

    map.setZoom( 5 )

    center_map( map )

}

function markerClickFn( content, location, doingwhat ) {
    return function(e) {

        if ( e ) {
            e.cancelBubble = true;
            e.returnValue = false;

            if ( e.stopPropagation ) {
                e.stopPropagation();
                e.preventDefault();
            }
        }

        var info_bubble_content = '<div>';
        	if (content.ex_url != ''){
        		info_bubble_content += '<div class="storefinder__map__infobox__logo"><a href ="' + content.ex_url + '" target="_blank"><img src="' + content.logo + '"></a></div>';
        	}else{
        		info_bubble_content += '<div class="storefinder__map__infobox__logo"><img src="' + content.logo + '"></div>';
        	}
        	info_bubble_content += '<div class="storefinder__map__infobox__title">' + content.title + '</div>';

        	info_bubble_content += '<div class="storefinder__map__infobox__name">' + content.name + ', ' + content.position + '</div>';

			if ( content.phone )
				info_bubble_content += '<div class="storefinder__map__infobox__phone content">'+ window.infobox_strings.phone +' <a href="tel:'+ content.phone + '">'+ content.phone + '</a></div>';

			if ( content.email )
				info_bubble_content += '<div class="storefinder__map__infobox__email content">'+ window.infobox_strings.email +' <a href="mailto:' + content.email + '">' + content.email + '</a></div>';

        	//info_bubble_content += '<div class="storefinder__map__infobox__directions"><a href="http://maps.google.com/?q=' + content.address + '" target="_blank">Get Directions</a></div>';

        info_bubble_content += '</div>';

        info_bubble.setPosition( location );
        info_bubble.setContent( info_bubble_content );
        info_bubble.open( map );

        if ( doingwhat == 'clicking' ) {
            map.panTo( location );
        }

        map.setZoom( 12 );

    }
}

function center_map() {

    var bounds = new google.maps.LatLngBounds();

    jQuery.each( markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    if ( markers.length == 1 ) {

        map.setCenter( bounds.getCenter() );

        map.setZoom( 14 );

    } else {

        map.fitBounds( bounds );

    }

}

function distance(lat1, lon1, lat2, lon2, unit = 'K') {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

    if (dist > 1) {
        dist = 1;
    }

    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515

    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }

    return dist
}

initMap();

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

if( typeof document.getElementById( 'storefinder' ) != 'undefined' && document.getElementById( 'storefinder' ) != null ){
	var vm = new Vue({
	    ready: function() {
			this.get_stores();
	    },
	    el: '#storefinder',
	    data: {
	        courts: '',
	        courts_nr: '',
	        provinces: '',
	        selected_province: '',
	        selected_province_name: '',
	        cities: '',
	        selected_city: '',
	        selected_city_name: '',
	        state_start: false,
	        state_sidebar_small: true,
	        state_results: false,
	        state_geo: false,
	        state_loading: false,
	        state_all:  true,
	        marker: '',
			ico_close : '',
			ico_chevron_right : '',
			ico_chevron_left : '',
			ico_location : '',
			ico_search : '',
			show_sidebar : false,
			search : '',
			state_addeddistances: false,
			directionsLink: ''
	    },
	    watch: {
	        'state_start': function() {
	            google.maps.event.trigger(map, "resize");
	        },
	        'state_sidebar_small': function() {
	            var current_center = map.getCenter();
	            google.maps.event.trigger(map, "resize");
	            map.setCenter( current_center );
	        },
	    },
	    methods: {

	        get_stores: function() {

	            this.state_loading = true;

				this.courts = window.locations;
				this.courts_nr = this.courts.length;

				this.state_results = true;

				if( this.courts && this.courts[0] && this.courts[0].address && this.courts[0].address.address )
					this.directionsLink = 'http://maps.google.com/?q=' + this.courts[0].address.address

				displayMarkers( window.locations );

				this.state_loading = false;

	        },

	        reset_start: function() {

	            this.selected_city = '';
	            this.selected_province = '';
	            this.state_results = false;
	            this.state_geo = false;

	            vm.get_cities();
	            vm.get_courts_all()

	        },

	        open_pin: function( pin_title ) {

	            var pin = String( pin_title )

	            var lookfor = markers.find(function(element, index, array) {
	                return element.title == pin;
	            })

				this.state_sidebar_small = window.state_sidebar_small

	            google.maps.event.trigger(lookfor, 'click')

	        }

	    }
	});
}
